<template>
  <div>
    <v-text-field
      v-model="value"
      :label="field.label"
      outlined
      dense
      type="number"
      @input="saveValueText($event)"
      v-if="!loading"
      :rules="!!this.field.required ? required : [] && rulesNumber"
    />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
export default {
  props: ["field", "model"],
  data() {
    return {
      value: [],
      loading: true,
      rulesNumber: [v => !isNaN(parseFloat(v)) || "Insira um valor numerico."],
      required: [v => !!v || `O campo ${this.field.label} é obrigarório`]
    };
  },
  mounted() {
    this.$emit('componentLoading', true);
    this.value = this.model;
    this.loading = false;
    this.$emit('componentLoading', false);
    this.$emit('fieldReady');
  },
  computed: {
    ...mapState("solicitation", ['solicitation_validate_values']),
  },
  methods: {
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapActions("solicitation", ["updateSolicitationValidateValues"]),
    saveValueText(selected) {
      this.updateSolicitationValidateValues({
        text: selected || "",
        value: selected || "",
        model: this.field.name
      });

      this.SET_FORM_EMAIL({});
      this.SET_FORM_EMAIL(this.solicitation_validate_values);
    }
  }
};
</script>
<style scoped></style>
